import React, { useState, useEffect } from 'react';
import { toast } from 'sonner';
import api from '../../api';
import { useGlobalContext } from '../../context';
import SideNav from '../components/SideNav';
import ReactDataTable from '../components/ReactDataTable';
import adminDashLinks from './adminDashLinks';

import { BsTrash } from "react-icons/bs";
import { AiOutlineClose } from "react-icons/ai";
import { GiHamburgerMenu } from "react-icons/gi";
import { BiLogOut } from "react-icons/bi";
import ConfirmModal from '../components/ConfirmModal';

const AdminUsers = () => {
  const { allUsersMongoData } = useGlobalContext();

  const [resetBalBtn, updateResetBalBtn] = useState(null);
  const [resetProfBtn, updateResetProfBtn] = useState(null);
  const [resetBonusBtn, updateResetBonusBtn] = useState(null);

  const [confirm, setConfirm] = useState(null);

  const [resetBal, resetBalUpdate] = useState({ email: "", amount: "" });
  const [resetProf, resetProfUpdate] = useState({ email: "", amount: "" });
  const [resetBonus, resetBonusUpdate] = useState({ email: "", amount: "" });

  const [navActive, updateNavActive] = useState(null);

  const clearSess = async () => {
    try { await api.post('/api/logout'); } catch (e) {}
    window.sessionStorage.clear();
  };

  const hideNav = () => updateNavActive(false);

  useEffect(() => {
    if (navActive) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [navActive]);

  const resetBalance = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/admin/resetbalance', { ...resetBal });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };


  const resetProfit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/admin/resetprofit', { ...resetProf });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const ResetBonus = async (e) => {
    e.preventDefault();
    try {
      const response = await api.post('/api/admin/resetbonus', { ...resetBonus });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const askConfirm = (title, message, onConfirm, confirmLabel, confirmClass) => {
    setConfirm({ title, message, onConfirm, confirmLabel, confirmClass });
  };

  const approveKYC = async (userEmail) => {
    try {
      const response = await api.post('/api/admin/approvekyc', { userEmail });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const rejectKYC = async (userEmail) => {
    try {
      const response = await api.post('/api/admin/rejectkyc', { userEmail });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const deleteUser = async (userEmail) => {
    try {
      const response = await api.delete('/api/admin/deleteuser', { data: { userEmail } });
      const responseData = response.data;
      if (responseData.errMsg) { toast.error(responseData.errMsg); }
      else { toast.success(responseData.successMsg); setTimeout(() => window.location.reload(), 5000); }
    } catch (error) { console.log(error); }
  };

  const columns = [
    {
      name: 'Date',
      selector: (row) => row.date,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{new Date(row.date).toLocaleDateString('en-GB')}</div>,
    },
    {
      name: 'Email',
      selector: row => row.email,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.email}</div>,
    },
    {
      name: 'Username',
      selector: row => row.username,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.username}</div>,
    },
    {
      name: 'Balance',
      selector: row => row.balance,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>${parseFloat(row.balance).toLocaleString()}</div>,
    },
    {
      name: 'Profit',
      selector: row => row.profit,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>${parseFloat(row.profit).toLocaleString()}</div>,
    },
    {
      name: 'Bonus',
      selector: row => row.bonus,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>${parseFloat(row.bonus).toLocaleString()}</div>,
    },
    {
      name: 'Invested',
      selector: row => row.invested,
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>${parseFloat(row.invested || 0).toLocaleString()}</div>,
    },
    {
      name: 'KYC',
      selector: row => row.kycStatus,
      cell: (row) => {
        const colors = { verified: 'text-green-400', pending: 'text-yellow-400', rejected: 'text-red-400', unverified: 'text-[#A9ABAD]' };
        return <div style={{ whiteSpace: 'normal' }} className={colors[row.kycStatus] || 'text-[#A9ABAD]'}>{row.kycStatus || 'unverified'}</div>;
      },
    },
    {
      name: 'Admin',
      selector: row => row.isAdmin.toString(),
      cell: (row) => <div style={{ whiteSpace: 'normal' }}>{row.isAdmin.toString()}</div>,
    },
    {
      name: 'Action',
      cell: (row) => (
        <div style={{ whiteSpace: 'nowrap', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <button onClick={() => askConfirm('Delete User', `Delete ${row.email}? This cannot be undone.`, () => deleteUser(row.email))} className="bg-red-700 text-white flex justify-center items-center min-w-[32px] h-[28px] rounded-lg px-2"><BsTrash /></button>
          {row.kycStatus === 'pending' && (
            <>
              <button onClick={() => askConfirm('Reject KYC', `Reject KYC for ${row.email}?`, () => rejectKYC(row.email), 'Reject', 'bg-red-500 hover:bg-red-600')} className="bg-red-400 text-white flex justify-center items-center min-w-[32px] h-[28px] rounded-lg px-2 text-[12px]">✕</button>
              <button onClick={() => askConfirm('Approve KYC', `Approve KYC for ${row.email}?`, () => approveKYC(row.email), 'Approve', 'bg-green-700 hover:bg-green-800')} className="bg-green-700 text-white flex justify-center items-center min-w-[32px] h-[28px] rounded-lg px-2 text-[11px] font-[500]">KYC</button>
            </>
          )}
        </div>
      ),
    },
  ];

  const modalClass = "fixed w-full min-h-full top-0 left-0 flex justify-center items-center bg-black/80 z-50";
  const modalInner = "relative w-[90%] flex flex-col justify-start items-start space-y-5 bg-[#181C26] border border-[#1f2535] p-6 rounded-xl sm:w-[420px]";
  const inputClass = "bg-[#0d1017] px-3 border border-[#1f2535] rounded-lg w-full h-[45px] text-white text-[16px] focus:outline-none focus:border-[#473ECD] transition-colors";
  const labelClass = "text-[11px] text-[#A9ABAD] uppercase tracking-widest";
  const submitClass = "w-full min-h-[44px] flex justify-center items-center text-[14px] font-[500] bg-userDashPurple text-white rounded-lg transition-all ease-in duration-200 hover:bg-[#3d34b5]";

  return (
    <div className="absolute overflow-x-hidden w-full min-h-full text-white bg-black">
      <SideNav
        hideNav={hideNav}
        logout="/signin"
        logoutBtn={clearSess}
        translateAction={navActive ? `translate-x-[0px]` : `translate-x-[-500px]`}
        backgroundColor="bg-black"
        iconBorderColor="border-black"
        iconBgColor="bg-inherit"
        textColor="text-white"
        links={adminDashLinks}
        logouticon={
          <BiLogOut className="cursor-pointer text-[20px] text-white transition-all ease-in duration-300 hover:scale-[1.1]" />
        }
      />

      {navActive && (
        <div className="fixed inset-0 bg-black/60 z-40 xl:hidden" onClick={hideNav} />
      )}

      {confirm && (
        <ConfirmModal
          title={confirm.title}
          message={confirm.message}
          confirmLabel={confirm.confirmLabel}
          confirmClass={confirm.confirmClass}
          onConfirm={() => { confirm.onConfirm(); setConfirm(null); }}
          onCancel={() => setConfirm(null)}
        />
      )}

      {/* Reset Balance Modal */}
      {resetBalBtn && (
        <div className={modalClass}>
          <div className={modalInner}>
            <div className="w-full flex justify-between items-center">
              <h4 className="text-white font-[600] text-[16px]">Reset Balance</h4>
              <button onClick={() => updateResetBalBtn(false)}>
                <AiOutlineClose className="text-[#A9ABAD] text-[20px] hover:text-white transition-colors" />
              </button>
            </div>
            <form className="w-full flex flex-col space-y-4" onSubmit={resetBalance}>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Select User</label>
                <select name="email" value={resetBal.email} className={inputClass} onChange={(e) => resetBalUpdate({ ...resetBal, email: e.target.value })}>
                  <option value="">-- Select a user --</option>
                  {Array.isArray(allUsersMongoData) && allUsersMongoData.map((user) => (
                    <option key={user._id} value={user.email}>{user.username} — {user.email}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Amount</label>
                <input type="text" name="amount" className={inputClass} onChange={(e) => resetBalUpdate({ ...resetBal, [e.target.name]: e.target.value })} />
              </div>
              <button type="submit" className={submitClass}>Update</button>
            </form>
          </div>
        </div>
      )}

      {/* Reset Profit Modal */}
      {resetProfBtn && (
        <div className={modalClass}>
          <div className={modalInner}>
            <div className="w-full flex justify-between items-center">
              <h4 className="text-white font-[600] text-[16px]">Reset Profit</h4>
              <button onClick={() => updateResetProfBtn(false)}>
                <AiOutlineClose className="text-[#A9ABAD] text-[20px] hover:text-white transition-colors" />
              </button>
            </div>
            <form className="w-full flex flex-col space-y-4" onSubmit={resetProfit}>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Select User</label>
                <select name="email" value={resetProf.email} className={inputClass} onChange={(e) => resetProfUpdate({ ...resetProf, email: e.target.value })}>
                  <option value="">-- Select a user --</option>
                  {Array.isArray(allUsersMongoData) && allUsersMongoData.map((user) => (
                    <option key={user._id} value={user.email}>{user.username} — {user.email}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Amount</label>
                <input type="text" name="amount" className={inputClass} onChange={(e) => resetProfUpdate({ ...resetProf, [e.target.name]: e.target.value })} />
              </div>
              <button type="submit" className={submitClass}>Update</button>
            </form>
          </div>
        </div>
      )}

      {/* Reset Bonus Modal */}
      {resetBonusBtn && (
        <div className={modalClass}>
          <div className={modalInner}>
            <div className="w-full flex justify-between items-center">
              <h4 className="text-white font-[600] text-[16px]">Reset Bonus</h4>
              <button onClick={() => updateResetBonusBtn(false)}>
                <AiOutlineClose className="text-[#A9ABAD] text-[20px] hover:text-white transition-colors" />
              </button>
            </div>
            <form className="w-full flex flex-col space-y-4" onSubmit={ResetBonus}>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Select User</label>
                <select name="email" value={resetBonus.email} className={inputClass} onChange={(e) => resetBonusUpdate({ ...resetBonus, email: e.target.value })}>
                  <option value="">-- Select a user --</option>
                  {Array.isArray(allUsersMongoData) && allUsersMongoData.map((user) => (
                    <option key={user._id} value={user.email}>{user.username} — {user.email}</option>
                  ))}
                </select>
              </div>
              <div className="flex flex-col space-y-2">
                <label className={labelClass}>Amount</label>
                <input type="text" name="amount" className={inputClass} onChange={(e) => resetBonusUpdate({ ...resetBonus, [e.target.name]: e.target.value })} />
              </div>
              <button type="submit" className={submitClass}>Update</button>
            </form>
          </div>
        </div>
      )}


      <div className="relative flex flex-col flex-grow w-full h-full px-4 mb-[100px] xl:pl-[304px] xl:pr-6">
        {/* top nav */}
        <nav className="relative w-full min-h-[100px] flex justify-center items-start pt-3">
          <div className="relative w-full min-h-[50px] flex justify-between items-center xl:justify-end">
            <button onClick={() => updateNavActive(true)} className="relative xl:hidden">
              <GiHamburgerMenu className="text-[20px] text-[#A9ABAD]" />
            </button>
          </div>
        </nav>

        {/* page header */}
        <div className="relative w-full flex flex-col justify-start items-start space-y-1 pt-4 pb-8">
          <h3 className="text-[20px] font-[600] text-white">Manage Users</h3>
          <p className="text-[#A9ABAD] text-[14px]">View and manage registered user accounts.</p>
        </div>

        {/* action buttons */}
        <div className="flex flex-wrap gap-3 pb-8">
          <button onClick={() => updateResetBalBtn(true)} className="min-h-[38px] px-4 flex justify-center items-center text-[13px] font-[500] bg-[#181C26] border border-[#1f2535] text-white rounded-lg hover:border-[#473ECD] transition-colors">Reset Balance</button>
          <button onClick={() => updateResetProfBtn(true)} className="min-h-[38px] px-4 flex justify-center items-center text-[13px] font-[500] bg-[#181C26] border border-[#1f2535] text-white rounded-lg hover:border-[#473ECD] transition-colors">Reset Profit</button>
          <button onClick={() => updateResetBonusBtn(true)} className="min-h-[38px] px-4 flex justify-center items-center text-[13px] font-[500] bg-[#181C26] border border-[#1f2535] text-white rounded-lg hover:border-[#473ECD] transition-colors">Reset Bonus</button>
        </div>

        {/* table */}
        <div className="relative w-full overflow-x-auto">
          <ReactDataTable columns={columns} data={allUsersMongoData} />
        </div>
      </div>
    </div>
  );
};

export default AdminUsers;
